import { useAuthStore } from '@/store/use-auth-store';
import { syncSessionFromBackend } from '@/utils/sync-auth-session';
import { useQueryClient } from '@tanstack/react-query';

export const useSetUserInfo = () => {
  const queryClient = useQueryClient();
  const setSession = useAuthStore((state) => state.setSession);

  const setUserInfoMutation = async (options?: { tenantId?: number }) => {
    try {
      const data = await syncSessionFromBackend({
        tenantId: options?.tenantId,
        queryClient,
      });

      setSession('sso');

      return {
        user: data.user,
        tenant: data.current_tenant,
        cohorts: data.current_cohorts ?? [],
      };
    } catch (error) {
      console.error('Error setting user info:', error);
      throw error;
    }
  };

  return { setUserInfo: setUserInfoMutation };
};
